import AddUserPlan from './component'

export default AddUserPlan
